import { Translate } from '@/shared/i18n';
import { SpacesFeature } from '@/shared/types/Settings';

export const getUpgradeAlertText = ({ enabled, metadata }: SpacesFeature, t: Translate, extraSeats = 0) => {
  const userLimit = metadata?.user_limit ?? 0;

  if (!enabled && !extraSeats) return t('teamspace.upgrade.inviteUsers');

  // Минимум 1 место всегда под владельца; extra seats добавляются сверх этого
  const totalSeats = Math.max(userLimit, 1) + extraSeats;
  return t('teamspace.upgrade.planMembers', { count: totalSeats });
};
